import ListingVM from './listing-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init(node) {
    console.log('Kadenze.InstructorModuleListing Init function called');

    const courseId = node.dataset.courseId;
    const modules = JSON.parse(node.dataset.modules);
    const modulables = JSON.parse(node.dataset.modulables);

    const vm = new Vue(ListingVM);
    vm.$mount(node);
    vm.bindData(courseId, modules, modulables);
  }
};

